import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import * as moment from 'moment';
import { CommonService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';
import { AlertService, Constants, Moment$ } from 'src/app/shared';

@Component({
  selector: 'app-energy-tree-excel',
  templateUrl: './energy-tree-excel.component.html',
  styleUrls: ['./energy-tree-excel.component.scss']
})
export class EnergyTreeExcelComponent implements OnInit {
  siteId = '';
  siteName = '';
  startView = 'month';
  max = new Date();
  date = new FormControl(new Date());
  enddate = new FormControl(new Date());
  navigationSubscription: any;
  fileName: string;

  constructor(public commonService: CommonService, private activeRoute: ActivatedRoute,
    private dataService: DataService, private _http: HttpClient,
    private alertService: AlertService, private router: Router) { 
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
       console.log('Router event:', e);
      if (e instanceof (NavigationEnd)) {
        this.siteId = localStorage.getItem('siteId');
        this.siteName = localStorage.getItem('siteName');
      }
    });
  }
  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
       this.navigationSubscription.unsubscribe();
    }
  }

  ok() {
    let url = '';
    let reportName= 'EnergyReport';
    if (this.date.value && this.enddate.value) {
      const selecteddate = moment(this.date.value).format('YYYY-MM-DD');
      const selectedenddate = moment(this.enddate.value).format('YYYY-MM-DD');

      if(selecteddate<=selectedenddate){
        url = this.commonService.getEnergyTreeReportUrl(this.siteId, selecteddate,selectedenddate);

        
        this.fileName= this.siteName + "_" + reportName + "_" + selecteddate + "_" + selectedenddate ;


        this.dataService.getPDF(url, true).subscribe((response) => {
        if (response.byteLength > 0) {
          const file = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const fileURL = URL.createObjectURL(file);

          // Provide filename to the exported file
          const fileName = document.createElement('a')
          fileName.href = fileURL
          fileName.download = this.fileName;
          fileName.click();
          URL.revokeObjectURL(fileURL);
          
        } else {
          this.alertService.message = 'No Data present for selected duration';
          this.alertService.showError();
        }

      });
      }
      else {
        this.alertService.message = 'From date can not be greater than To date';
        this.alertService.showError();
      }
    }
    else {
      this.alertService.message = 'Incorrect Date, Please try again';
      this.alertService.showError();
    }
  }
}
